// import { useTheme } from '@mui/material/styles';
// We could use the themes to override a color or something

const MinifiedLogo = () => (
    // const theme = useTheme();

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="-0.637 233 30 30" width="30pt" height="30pt">
        <g>
            <g>
                <g>
                    <g>
                        <circle cx="14.362696443341605" cy="248" r="15" fill="rgb(8,20,247)" />
                        <g>
                            <g>
                                <path
                                    d=" M 18.619 259 C 13.867 259 10 255.133 10 250.381 L 10 245.932 L 14.452 245.932 L 14.452 250.381 C 14.452 252.677 16.32 254.548 18.619 254.548 L 18.619 259 Z "
                                    fill="rgb(255,255,255)"
                                />
                                <rect x="10" y="237" width="4.452" height="4.482" transform="matrix(1,0,0,1,0,0)" fill="rgb(255,255,255)" />
                                <rect
                                    x="14.455"
                                    y="241.479"
                                    width="4.27"
                                    height="4.452"
                                    transform="matrix(1,0,0,1,0,0)"
                                    fill="rgb(255,255,255)"
                                />
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
export default MinifiedLogo;
